import {
  Popover,
  PopoverTrigger,
  Button,
  Text,
  PopoverContent,
  PopoverBody,
  useColorModeValue,
  PopoverContentProps,
  PopoverBodyProps,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { TEXT_COLOR_LIGHT, TEXT_COLOR_DARK } from "./utils";
import { ChevronDownIcon } from "@chakra-ui/icons";

interface Props {
  isActive: boolean;
  property: string | JSX.Element;
  value: string | JSX.Element;
  popupWidth?: string;
  popoverContentProps?: PopoverContentProps;
  popoverBodyProps?: PopoverBodyProps;
  children: string | JSX.Element | JSX.Element[];
}

export function CustomPopover({
  isActive,
  property,
  value,
  children,
  popupWidth = "250px",
  popoverBodyProps = {},
  popoverContentProps = {},
}: Props) {
  const textColor = useColorModeValue(TEXT_COLOR_LIGHT, TEXT_COLOR_DARK);

  return (
    <Popover>
      {({ isOpen }) => (
        <>
          <PopoverTrigger>
            <Button
              borderColor={isActive ? textColor : "none"}
              border={isActive ? "2px solid" : "none"}
              bg="white"
              size="sm"
              boxShadow="md"
              color={textColor}
              rightIcon={
                <motion.div
                  animate={{
                    rotate: isOpen ? 180 : 0,
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <ChevronDownIcon />
                </motion.div>
              }
            >
              <Text as="span" fontWeight="normal">
                {property}:
              </Text>
              &nbsp;
              <Text as="span" fontWeight="semibold">
                {value}
              </Text>
            </Button>
          </PopoverTrigger>
          {isOpen ? (
            <PopoverContent w={popupWidth} {...popoverContentProps}>
              <PopoverBody {...popoverBodyProps}>{children}</PopoverBody>
            </PopoverContent>
          ) : null}
        </>
      )}
    </Popover>
  );
}
